export const resolveUserModel3DUrl = (
  url: string | null | undefined,
): string | undefined => {
  if (!url) return undefined;

  const serverUri = process.env.REACT_APP_SERVER_URI;
  if (!serverUri) return url;

  try {
    return new URL(url, serverUri).toString();
  } catch {
    return url;
  }
};
